<template lang="html">
  <div id="floorplan-detail-nav"
  class="col-lg-12 col-md-12 col-12">
    <div class="row align-items-center justify-content-between h-100">
      <!-- Prev -->
      <div class="nav-block text-left">
        <router-link :to="{ name: 'FloorplanDetail', params: { id: floorplan.prev.id }}"
        tag="button" v-if="floorplan.prev"
        class="btn btn-link-action">
          <i class="far fa-angle-left mr-2"></i> <span v-html="floorplan.prev.name"/>
        </router-link>
      </div>

      <!-- Name -->
      <div class="d-none d-lg-block">
        {{ navText }}
      </div>

      <!-- Next -->
      <div class="nav-block text-right">
        <router-link :to="{ name: 'FloorplanDetail', params: { id: floorplan.next.id }}"
        tag="button" v-if="floorplan.next"
        class="btn btn-link-action">
          <span v-html="floorplan.next.name"/> <i class="far fa-angle-right ml-2"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'floorplan-detail-nav',
  props: {
    floorplan: {
      type: Object,
      default: () => ({})
    },
    navText: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleArrowKeys(e) {
      if (!e.metaKey && e.keyCode === 39) {
        if (this.floorplan.next) {
          this.$router.push({ name: 'FloorplanDetail', params: { id: this.floorplan.next.id } });
        }
      } else if (!e.metaKey && e.keyCode === 37) {
        if (this.floorplan.prev) {
          this.$router.push({ name: 'FloorplanDetail', params: { id: this.floorplan.prev.id } });
        }
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.handleArrowKeys);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleArrowKeys);
  }
};
</script>

<style lang="scss" scoped>
#floorplan-detail-nav {
  bottom: 0;
  height: $bottom-bar-height;
  background-color: var(--background);

  span.favourite {
    visibility: visible;
    &.invisible { visibility: hidden; }
  }
}

.nav-block {

}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailNav.vue